import type { SVGProps } from "react";
export interface TwitterIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TwitterIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TwitterIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.646 2.888c1.041.076 2.028.456 2.928.976h1.917c.671 0 1.167.403 1.414.842.214.382.296.881.136 1.365l-.084.207-1.047 2.155c-.074 5.44-2.425 9.286-6.177 11.24-3.748 1.954-8.669 1.904-13.619.052a1.126 1.126 0 0 1 .245-2.17c1.23-.163 2.15-.416 2.868-.777-1.51-1.53-2.56-3.065-3.249-4.714C1.146 10.07.875 7.988.875 5.68c0-1.28 1.442-2.12 2.525-1.383l.213.17.488.438C6.257 6.78 8.417 7.821 11.07 8.04c.046-.607.143-1.191.332-1.742.322-.94.892-1.721 1.785-2.379l.415-.278a5.03 5.03 0 0 1 3.042-.753m-.163 2.244c-.645-.046-1.294.11-1.962.6-.541.4-.822.81-.99 1.297-.182.531-.249 1.21-.249 2.184 0 .621-.504 1.125-1.125 1.125-3.56 0-6.372-1.158-8.991-3.28.094 1.536.361 2.879.888 4.14.676 1.62 1.811 3.186 3.697 4.878a1.126 1.126 0 0 1 .018 1.658c-.371.347-.776.637-1.212.885 3.124.545 5.947.2 8.136-.94 2.951-1.538 4.971-4.628 4.972-9.512 0-.17.038-.339.112-.492l.76-1.561h-1.27c-.211 0-.417-.06-.596-.17-.78-.486-1.515-.763-2.188-.812"
      />
    </svg>
  );
}
